import { render } from "./TokenView.vue?vue&type=template&id=cd11d356"
import script from "./TokenView.vue?vue&type=script&lang=js"
export * from "./TokenView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__